import { useState, useCallback } from 'react';
import { useLazyEffect } from './lazy.js';
import { logDebug } from '../../utils/debug/logger.js';

function useMetaKey() {
    const [metaKeyPressed, setMetaKeyPressed] = useState(false);
    const handlerKeyDown = useCallback((e) => {
        if (e.metaKey || e.ctrlKey) {
            logDebug('User is typing CMD key', e);
            setMetaKeyPressed(true);
        }
    }, []);
    const handlerKeyUp = useCallback(() => {
        setMetaKeyPressed(false);
    }, []);
    useLazyEffect(() => {
        document.addEventListener('keydown', handlerKeyDown, false);
        document.addEventListener('keyup', handlerKeyUp, false);
        return () => {
            document.removeEventListener('keydown', handlerKeyDown, false);
            document.removeEventListener('keyup', handlerKeyUp, false);
        };
    }, [handlerKeyDown, handlerKeyUp], false);
    return metaKeyPressed;
}

export { useMetaKey };
//# sourceMappingURL=keys.js.map
